var app_preloadPictures = null;
(function ($) {

    app_preloadPictures = function (pictureUrls, callback) {
        var i, j, loaded = 0;

        for (i = 0, j = pictureUrls.length; i < j; i++) {
            createImg(new Image(), pictureUrls[i]);
        }

        function createImg(img, src) {  
            img.onload = function () {
                if (++loaded === pictureUrls.length && callback) {
                    callback();
                }
            };

            img.onerror = function () {};
            img.onabort = function () {};
            img.src = src;

            if (i === 0) {
                $("#view1").append(img);
                $("#view1").show();
            } else {
                $("#view" + (i + 1)).append(img); 
            }
        }
    };

})(jQuery);
